import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/attachment.svg'


const _hoisted_1 = { class: "space-y-6 mb-10" }
const _hoisted_2 = { class: "flex flex-wrap flex-col gap-y-8 px-4" }
const _hoisted_3 = { class: "flex items-center w-full" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_0,
  alt: "attachment"
}, null, -1)
const _hoisted_5 = { class: "ml-2 whitespace-no-wrap" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_0,
  alt: "attachment"
}, null, -1)
const _hoisted_8 = { class: "ml-2 whitespace-no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      class: "px-4",
      label: "Berkas Lampiran"
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: "Berkas Lampiran Asli",
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.successFile), 1),
            _createVNode(_component_lp_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.download(_ctx.detailData.successFile, _ctx.successFile))),
              "text-color": "red-lp-300",
              flat: "",
              small: "",
              icon: "download"
            })
          ])
        ]),
        _: 1
      }),
      (_ctx.detailData.commissionStatus !== 'success')
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 0,
            label: "Berkas Lampiran Gagal",
            class: "border-dotted border-2 mb-8 border-red-lp-300 w-400px"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.failedFile), 1),
                _createVNode(_component_lp_button, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.download(_ctx.detailData.failedFile, _ctx.failedFile))),
                  "text-color": "red-lp-300",
                  flat: "",
                  small: "",
                  icon: "download"
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}